import { create } from 'zustand';
import { enableMapSet } from 'immer';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { IS_DEV } from 'lib/constants';
import createUISlice, { UISlice } from './slices/ui';
import createUserSlice, { UserSlice } from './slices/user';
import createBuyApartmentSlice, { BuyApartmentSlice } from './slices/buy-apartment';
import createSellApartmentSlice, { SellApartmentSlice } from './slices/sell-apartment';
import createNotificationFilterSlice, {
  NotificationFilterSlice,
} from './slices/notification-filter';

// TODO load conditionally in dev
import 'set.prototype.tojson';
import createSellApartmentSecondarySlice, {
  SellApartmentSecondarySlice,
} from './slices/sell-apartment-secondary';
import createBuyApartmentSliceSecondary, {
  BuyApartmentSliceSecondary,
} from './slices/buy-apartment-secondary';
import createFavoriteSlice, { FavoriteSlice } from './slices/favorite-list';

enableMapSet();

export type Store = UISlice &
  UserSlice &
  BuyApartmentSlice &
  BuyApartmentSliceSecondary &
  SellApartmentSlice &
  NotificationFilterSlice &
  SellApartmentSecondarySlice &
  FavoriteSlice

const useBoundStore = create<Store>()(
  immer(
    devtools(
      (...a) => ({
        ...createUISlice(...a),
        ...createUserSlice(...a),
        ...createNotificationFilterSlice(...a),
        ...createBuyApartmentSlice(...a),
        ...createBuyApartmentSliceSecondary(...a),
        ...createSellApartmentSlice(...a),
        ...createSellApartmentSecondarySlice(...a),
        ...createFavoriteSlice(...a),
      }),
      { enabled: IS_DEV },
    ),
  ),
);

export default useBoundStore;
